



































































import * as Enums from '@/enums.ts';
import * as Util from '@/util.ts';
import Vue from 'vue';
import { format } from 'date-fns';

export default Vue.extend({
  data() {
    return {
      payments: [],
      eChargeStatuses: Enums.eChargeStatuses,
    };
  },
  mounted() {
    this.onPageLoad();
  },
  watch: {
    $route(to, from) {
      if (to.fullPath.includes('/past-orders')) {
        this.onPageLoad();
      }
    },
  },
  methods: {
    formatDate(dateInMs: number): string {
      return format(new Date(dateInMs), 'yyyy-MM-dd h:mm a');
    },
    formatCurrency(price: number): string {
      return Util.formatCurrency(price);
    },
    onPageLoad() {
      if (!this.$store.state.currentClientUserDoc) {
        return;
      }
      Util.showLoading();
      this.$data.payments = [];
      this.$store.state.currentClientUserDoc
        .collection('payments')
        .orderBy('dateCreated', 'desc')
        .limit(10)
        .get()
        .then((querySnapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>) => {
          Util.hideLoading();
          querySnapshot.forEach((doc: firebase.firestore.DocumentSnapshot) => {
            const payment = doc.data() as UserPaymentRecord;
            this.$data.payments.push(payment);
          });
        })
        .catch((error: any) => {
          Util.showError('Could not get recent orders. ' + error?.message);
        })
        .finally(() => {
          Util.hideLoading();
        });
    },
  },
});
